import { User } from "types";
import { api } from "./base.api";

export const authAPI = {
  login: async (email: string, password: string, turnstileToken: string) => {
    const response = await api.post("/auth/login", {
      email,
      password,
      turnstileToken,
    });
    return response.data;
  },

  register: async (
    email: string,
    password: string,
    firstName?: string,
    lastName?: string,
    referralCode?: string,
    turnstileToken?: string
  ) => {
    const response = await api.post("/auth/register", {
      email,
      password,
      firstName,
      lastName,
      referralCode,
      turnstileToken,
    });
    return response.data;
  },

  // googleAuth: async (token: string) => {
  //   const response = await api.post("/auth/google", { token });
  //   return response.data;
  // },
  // googleAuth: () => {
  //   const referralCode = sessionStorage.getItem("referralCode");
  //   const googleAuthUrl = `${API_URL}/auth/google${
  //     referralCode ? `?referralCode=${referralCode}` : ""
  //   }`;
  //   window.location.href = googleAuthUrl;
  // },

  googleAuth: async (token: string, referralCode?: string) => {
    localStorage.setItem("token", token);
    return { access_token: token };
  },
  forgotPassword: async (email: string) => {
    const response = await api.post("/auth/forgot-password", { email });
    return response.data;
  },

  resetPassword: async (token: string, password: string) => {
    const response = await api.post("/auth/reset-password", {
      token,
      password,
    });
    return response.data;
  },

  verifyEmail: async (token: string) => {
    const response = await api.get(`/auth/verify-email/${token}`);
    return response.data;
  },

  resendVerification: async (email: string) => {
    const response = await api.post("/auth/resend-verification", { email });
    return response.data;
  },
};

export const userAPI = {
  getCurrentUser: async () => {
    const response = await api.get("/users/me");
    return response.data;
  },

  updateProfile: async (data: {
    firstName?: string;
    lastName?: string;
    cpf?: string;
    birthday?: string;
  }) => {
    const response = await api.patch("/users/me", data);
    return response.data;
  },

  generateArariaApiKey: async () => {
    const response = await api.post("/users/araria-api-key");
    return response.data;
  },

  updatePreferences: async (data: {
    theme?: string;
    language?: string;
    lastModel?: string;
    lastImageModel?: string;
    allowedDomains?: string[];
  }) => {
    const response = await api.patch("/users/preferences", data);
    return response.data;
  },

  updatePassword: async (currentPassword: string, newPassword: string) => {
    const response = await api.patch("/users/password", {
      currentPassword,
      newPassword,
    });
    return response.data;
  },

  setPassword: async (newPassword: string) => {
    const response = await api.post("/users/password", {
      newPassword,
    });
    return response.data;
  },

  becomeAffiliate: async () => {
    const response = await api.post("/users/become-affiliate");
    return response.data;
  },

  getReferralStats: async () => {
    const response = await api.get("/users/referral-stats");
    return response.data;
  },
  getTokenUsage: async (page = 1, limit = 10) => {
    const response = await api.get(`/subscriptions/usage/${page}/${limit}`);
    return response.data;
  },

  findAll: async (page = 1, limit = 2) => {
    const response = await api.get<{
      users: User[];
      pagination: {
        total: number;
        page: number;
        limit: number;
        pages: number;
      };
    }>(`/users/all?page=${page}&limit=${limit}`);
    return response.data;
  },
};
